export default {
  id: "StudentSettings",
  code: "CN",
  text: {
    'Student': '学员',
    'Input Fields Setting': '学生报名信息设置',
    'Basic Info': '基本信息',
    'Name': '学员姓名',
    'Last Name': '学员姓',
    'First Name': '学员名',
    'Gender': '学员性别',
    'DOB': '学员生日',
    'Mobile Number': '学员手机',
    'Nickname': '学员昵称',
    'Email': '学生邮箱',
    'Current Address': '现居地址',

		'Country': '国家',
		'Province/States': '地区',
    'City': '城市',
    'Street': '街道地址',
    'Unit No.': '门牌号',
    'Postal Code': '邮政编码',

    'Remark': '备注',
    'Primary Guardian Name': '家长1姓名',
    'Primary Guardian Relationship': '家长1亲属关系',
    'Primary Guardian Phone': '家长1电话',
    'Primary Guardian Email': '家长1邮箱',
    'Secondary Guardian Name': '家长2姓名',
    'Secondary Guardian Relationship': '家长2亲属关系',
    'Secondary Guardian Phone': '家长2电话',
    'Secondary Guardian Email': '家长2邮箱',

    'Country Code': '国家代码',

    'Save': '保存'
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/StudentSettings/locale.js